<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div style="background-color: #002956e6;" class="contactHeader">
        <div class="container green containerHeader">
            <div>
                <a style="text-decoration: none; padding-right: 20px;" href="tel:+59352526497" target="_blank">
                    <i class="fa fa-phone" style="padding: 0 10px;"></i>
                    (+593-5) 2526-497</a>
                <a href="mailto:info&#64;scubaiguana.com" target="_blank">
                    <i class="fa fa-envelope-o" style="padding: 0 10px;"></i>
                    info&#64;scubaiguana.com</a>
            </div>
            <div>
                <a href="https://api.whatsapp.com/send/?phone=593997024031" target="_blank"><i class="fa fa-whatsapp"
                        style="padding: 0 20px; font-size: 1.5em;"></i></a>
            </div>
            <a href="https://scubaiguana.com/contact-us/3" target="_blank"
                style="padding: 3px 15px; background-color: red;color: white; font-family: 'Arial Narrow', Arial, sans-serif;">RESERVATIONS</a>
        </div>
    </div>
    <div #header1 class="container green containerMenu">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="assets/img/logo.jpg" height="78" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://scubaiguana.com/" class="navbar-brand"
            target="_blank" style="padding: 0;">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="../assets/images/logos-header/si.svg" alt="logo" class="brand-logo logo-desktop"
                style="height: 75px;">
            <img src="../assets/images/logos-header/sih.svg" alt="logo" class="brand-logo logo-mobile"
                style="height: 60px; padding: 5px 0">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="width: inherit;">
            <ul class="navbar-nav menuContainer" style="width: inherit;">
                <li class="nav-item menuItem"><a href="https://scubaiguana.com/our-dive-center/" target="_blank">OUR
                        DIVE CENTER <i class="fa fa-angle-down"></i></a></li>
                <li class="nav-item menuItem"><a
                        href="https://scubaiguana.com/dive-travel-packages/dive-and-travel-packages-v2/"
                        target="_blank">DIVE AND TRAVEL PACKAGES <i class="fa fa-angle-down"></i></a></li>
                <li class="nav-item menuItem"><a href="https://scubaiguana.com/galapagos-info/"
                        target="_blank">GALAPAGOS INFO <i class="fa fa-angle-down"></i></a></li>
                <li class="nav-item menuItem"><a href="https://scubaiguana.com/about-us/" target="_blank">ABOUT
                        US</a></li>
                <li class="nav-item menuItem"><a href="https://scubaiguana.com/contact-us/" target="_blank">CONTACT
                        US</a>
                </li>
            </ul>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>
        <div class="container green containerHeader" style="justify-content: end; flex-direction: row!important;"
            class="responsiveHeader">
            <a href="https://scubaiguana.com/contact-us/3" target="_blank" style="padding: 3px 15px; background-color: red;color: white; font-family: 'Arial Narrow', Arial, sans-serif;
                display: flex;align-items: center;font-size: 1.2em;">RESERVATIONS</a>
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()">
                <i class="fa fa-bars"
                    style="padding-left: 10px;display: flex;align-items: center;font-size: 1.4em;"></i>
            </a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://scubaiguana.com/our-dive-center/" target="_blank">OUR
                DIVE CENTER <i class="fa fa-angle-down"></i></a></li>
        <li class="nav-item menuItem"><a
                href="https://scubaiguana.com/dive-travel-packages/dive-and-travel-packages-v2/" target="_blank">DIVE
                AND TRAVEL PACKAGES <i class="fa fa-angle-down"></i></a></li>
        <li class="nav-item menuItem"><a href="https://scubaiguana.com/galapagos-info/" target="_blank">GALAPAGOS INFO
                <i class="fa fa-angle-down"></i></a></li>
        <li class="nav-item menuItem"><a href="https://scubaiguana.com/about-us/" target="_blank">ABOUT
                US</a></li>
        <li class="nav-item menuItem"><a href="https://scubaiguana.com/contact-us/" target="_blank">CONTACT
                US</a>
        </li>
        <li class="nav-item menuItem"> <a href="https://api.whatsapp.com/send/?phone=593997024031" target="_blank"><i
                    class="fa fa-whatsapp" style="font-size: 1.5em;"></i></a>
        </li>
        <li class="nav-item menuItem" style="display: flex; flex-direction: column;"> <a
                style="text-decoration: none; padding-right: 20px;" href="tel:+59352526497" target="_blank">
                <i class="fa fa-phone"></i>
                (+593-5) 2526-497</a>
            <a href="mailto:info&#64;scubaiguana.com" target="_blank">
                <i class="fa fa-envelope-o"></i>
                info&#64;scubaiguana.com</a>
        </li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>